import MessageDialog from '@/modules/popups/MessageDialog.svelte';
import {popupUtil} from '@/helper/popup';
import lang from '@/modules/homepage/HomePage.lang';
import gLang from './IpRestricted.lang';

export function createRestrictedDialog(LG) {
  popupUtil.create(MessageDialog, {title: LG(lang.Note), message: LG(gLang.restrictedMsg, {Email: 'support@phemex.zendesk.com'})});
}
